<template>
  <div ref="tabbar" class="emd-tabbar _bordered">
    <ul class="emd-tabbar__list display-grid" :style="styleObject">
      <li class="emd-tabbar__item" v-for="item in visibleItems" :key="item.label.key" :class="{ '_disabled': !hasPermission(item) }">
        <a
          class="emd-tabbar__link"
          :class="{ '_active': item.label.key === activeItem }"
          @click="action(item)">
          <span :class="itemClass">
            <b>{{ item.label.value }}</b>
          </span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'EmdTabList',
  data () {
    return {
      styleObject: {
        gridTemplateColumns: `repeat(${this.items.length}, 1fr)`
      }
    }
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    activeItem: {
      type: [String, Number],
      required: true
    },
    itemClass: {
      type: String,
      required: false,
      default: 'emd-text'
    }
  },
  computed: {
    visibleItems () {
      return this.items.filter(item => !item.hidden)
    },
    colsNumber () {
      return `repeat(${this.items.length}, 1fr);`
    },
    routesWizard () {
      return this.$store.getters.routesWizard
    }
  },
  methods: {
    action (item) {
      if (this.hasPermission(item)) {
        this.$emit('changed', item)
      }
    },
    hasPermission (route) {
      return this.routesWizard.find(item => {
        if (item.path === route.label.key) {
          return item.permission
        }
      })
    }
  }
}
</script>

<style>
.emd-tabbar .emeraldicons {
  height: 16px;
  width: 16px;
  vertical-align: -2px;
  margin-right: 8px;
}

.display-grid {
  display: grid !important;
}

.emd-tabbar__link {
  width: 100%;
  text-align: center;
}
</style>
